/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guest_Book_TermsInputs */

const en_guest_book_terms = /** @type {(inputs: Guest_Book_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By booking you accept the terms and the privacy policy.`)
};

const pl_guest_book_terms = /** @type {(inputs: Guest_Book_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwując, akceptujesz regulamin i politykę prywatności.`)
};

/**
* | output |
* | --- |
* | "By booking you accept the terms and the privacy policy." |
*
* @param {Guest_Book_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const guest_book_terms = /** @type {((inputs?: Guest_Book_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guest_Book_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_guest_book_terms(inputs)
	return en_guest_book_terms(inputs)
});